import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.STOCK_MOVE_SET_STOCK_MOVE_REASON_LIST]: (state, payload) => {
    state.stockMoveReasonList = payload.stockMoveReasonList

    const sortNumberList = payload.stockMoveReasonList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  },
  [mutationsTypes.STOCK_MOVE_SET_STOCK_MOVE_LIST]: (state, payload) => {
    state.stockMoveList = payload.storageMoveList
  }
}

export default Mutations
